import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { RouteProps } from 'react-router-dom';

import SizeComp from '../../../components/size/size';
import DataStore from '../../store/DataStore';
import messages from '../messages';
import { SizeTypes } from '../../../constants';
import classNames from 'classnames';
interface IDataStore {
  dataStore?: DataStore;
}

const Size: React.SFC<RouteProps & IDataStore> = ({ dataStore }) => {
  return (
    <div className={classNames('c-bubble__content')}>
      <FormattedMessage
        {...{
          ...messages.size,
          values: {
            age: dataStore.age
          }
        }}
      />
      <div className="o-flex o-flex--wrap o-flex--justify-space-around o-flex--align-end u-margin-horizontal-auto u-margin-vertical-small u-2-of-3-at-large">
        {SizeTypes.map(size => (
          <SizeComp
            key={size.label}
            size={size.label}
            onClick={() => dataStore.setSize(size)}
            selected={
              dataStore.size ? size.label == dataStore.size.label : false
            }
          />
        ))}
      </div>
    </div>
  );
};

export default inject('dataStore')(observer(Size));



// WEBPACK FOOTER //
// ./src/containers/fitting/components/Size.tsx